module.exports = (__webpack_require__(6370))(73935);